import React from 'react';
import { Card, Button } from 'antd';
import PreviewDates from 'components/DateRangePicker/date-preview';
import { COMPARE_PERIOD, getDefaultDateRange } from 'shared/constants/date';
import { gql } from '@apollo/client';
import { useQuery } from 'hooks/apollo';
import Drawer from 'components/Drawer';

const SEGMENTS_QUERY = gql`
  query Segments {
    segments {
      id
      title
    }
  }
`;

const AddSegmentDrawer = ({ open, onSubmit, onCancel, globalDateRange }) => {
  const { data } = useQuery(SEGMENTS_QUERY);
  return (
    <Drawer
      open={open}
      onCancel={onCancel}
      title="Add segment"
    >
      <h3>What type of segment do you want to add?</h3>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
        <Card title="Date comparison">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
            <div>Compare with data from a relative date period</div>
            <Button block onClick={() => onSubmit({ title: 'Previous period', dateRangeConfig: getDefaultDateRange({ compareToPrevious: true }) })}>
              Previous period
              <PreviewDates dateRange={{ ...globalDateRange, compareToPrevious: true }} compareOnly />
            </Button>
            <Button block onClick={() => onSubmit({ title: 'Previous year', dateRangeConfig: getDefaultDateRange({ compareToPrevious: true, comparePeriod: COMPARE_PERIOD.YEAR }) })}>
              Previous year
              <PreviewDates dateRange={{ ...globalDateRange, compareToPrevious: true, comparePeriod: COMPARE_PERIOD.YEAR }} compareOnly />
            </Button>
            <Button block onClick={() => onSubmit('custom-date-range')}>
              Custom date range
            </Button>
          </div>
        </Card>
        <Card title="Predefined">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
            <div>Use one of the predefined segments</div>
            {data?.segments?.map((segment) => (
              <Button key={segment.id} block onClick={() => onSubmit({ title: segment.title, query: { combinator: 'and', rules: [{ field: 'segment', value: segment.id, operator: '=' }] } })}>
                {segment.title}
              </Button>
            ))}
          </div>
        </Card>
        <Button block onClick={() => onSubmit('custom')}>Custom segment</Button>
      </div>

    </Drawer>
  );
};

export default AddSegmentDrawer;
